import React from 'react';
import { FiltersState } from 'src/domains/layouts/webview/components/filters/Filters.state';
import { FiltersSecondaryListSecondRow } from 'src/domains/layouts/webview/components/filtersSecondary/FiltersSecondary.style';
import { FilterSecondary } from 'src/domains/layouts/webview/components/filtersSecondary/FilterSecondary';
import { MatchType } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/markets';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';
import { observer } from 'src/utils/mobx-react';

interface SportsFiltersUnifiedMarketRowPropsType {
    eventsListState: UnifiedSportEventsListState;
    marketFiltersState: FiltersState<MatchType | null>;
}

export const SportsFiltersUnifiedMarketRow = observer(
    'SportsFiltersUnifiedMarketRow',
    ({ eventsListState, marketFiltersState }: SportsFiltersUnifiedMarketRowPropsType): JSX.Element => {
        return (
            <FiltersSecondaryListSecondRow data-testid='sports-market-filters'>
                {marketFiltersState.filters.map(({ id, key, label }) => (
                    <FilterSecondary
                        key={key}
                        isActive={eventsListState.filter_market === id}
                        onClick={marketFiltersState.bindSetActiveFilterId(id)}
                        dataTestFilterKey={key}
                    >
                        {label}
                    </FilterSecondary>
                ))}
            </FiltersSecondaryListSecondRow>
        );
    }
);
